import React from 'react';

import BaseFilterChip from './BaseFilterChip';

type Props = {
  value?: string | null;
  onDelete: () => void;
};
export default function EnvironmentFilterChip({ value, onDelete }: Props) {
  switch (value) {
    case 'LIVE':
      return <BaseFilterChip label="Live data" onDelete={onDelete} />;
    case 'SANDBOX':
      return <BaseFilterChip label="Test data" onDelete={onDelete} />;
    case 'ALL':
    default:
      return null;
  }
}
